'use client'

import { NavigationQueryResult } from '@repo/sanity/types'
import { Button } from '@repo/ui/components/button'
import { FunctionComponent } from 'react'
import { useNavigation } from '../../../providers/NavigationProvider'
import { SHEET, useSheet } from '../../../providers/SheetProvider'
import { PageDto } from '../../../types/page.types'

interface Props {
  pageDto: PageDto
  navigation: NavigationQueryResult
}

const SearchTriggerButton: FunctionComponent<Props> = ({ pageDto, navigation }) => {
  const { openSheet } = useSheet()
  const { shouldUseInverse } = useNavigation()

  return (
    <li>
      <Button variant={shouldUseInverse(navigation) ? 'navigationInverse' : 'navigationDefault'} onClick={() => openSheet(SHEET.SEARCH)}>
        {pageDto.dictionary?.navigation?.search || 'Search'}
      </Button>
    </li>
  )
}

export default SearchTriggerButton
